var PRECISION = 0.00001; // numbers less than this is considered as 0
export default function isNumberEqual(a, b, precision) {
    if (precision === void 0) { precision = PRECISION; }
    return Math.abs(a - b) < precision;
}
//# sourceMappingURL=is-number-equal.js.map